<template>
	<div class="detail">
		<div class="header">
			<el-row>
				<el-col :span="13" class="flex flex-align-center">
					<p class="PingFang">
						{{ row.activity_name }}
					</p>
					<p
						v-if="$auth.hasPermi('system:myActivities:copyLink')"
						class="fz-14 hover PingFang pointer ml-20"
						@click="copyActivityId(row.activity_url)"
					>
						<i class="el-icon-document-copy mr-4"></i>
						<span>复制报名链接</span>
					</p>
				</el-col>
			</el-row>
			<single :row="row"></single>
		</div>
		<div class="line mt-20 mb-14"></div>
		<div class="search mt-30 mb-30">
			<search :tabName="tabName" @onSubmit="onSubmit"></search>
		</div>
		<div class="multi-table">
			<updateTime :type="sync_type" ref="updateTime" @updateList="updateList"></updateTime>
			<el-tabs @tab-click="handleClick" v-model="tabName">
				<el-tab-pane v-for="(item, index) in tableArr" :name="`${item.audit_status}`" :key="index">
					<div slot="label" class="flex flex-align-center">
						<span class="mr-6">{{ item.audit_status_desc }}</span
						><span class="mr-6">{{ item.num || '0' }}</span>
						<el-tooltip
							effect="dark"
							:content="
								index === 2
									? '报名申请被团长拒绝的商品将展示在这里，部分商品允许重新报名'
									: '商家可以申请中途退出团长招商，退出成功的商品将展示在这里'
							"
						>
							<i v-if="index > 1" class="iconfont icon-a-help-circle-obangzhu-xian yx-color-info"></i>
						</el-tooltip>
					</div>
					<div class="tab">
						<div class="export">
							<el-tooltip placement="top">
								<el-button @click="exportFun" :loading="exportLoading">导出数据</el-button>
							</el-tooltip>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			<multi-table
				v-loading="loading"
				element-loading-text="加载中"
				element-loading-background="rgba(255, 255, 255)"
				ref="multiTable"
				:columns="columns"
				@gePartnerList="gePartnerList"
				:list="list"
				:options="options"
				:total="total"
			>
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</div>
	</div>
</template>
<script>
import single from '../../components/single.vue';
import updateTime from '../../components/updateTime.vue';
import search from './components/dySearch.vue';
import { activitySync, activityDetail, activityList, exportActivityList, auditActivity } from '@/api/secondColonelManage';
import { copy, copyFun } from '@/utils/common';
import { columns } from './dyColumns';
import { mapGetters } from 'vuex';
import empty from '@/views/common/empty/index.vue';
import { PLATFORM_DY, activityType, dyMyActivityUpStateList } from '@/utils/dataMap';
export default {
	name: 'detail',
	components: {
		search,
		single,
		updateTime,
		empty,
	},
	data() {
		return {
			tableArr: dyMyActivityUpStateList,
			row: {},
			tabName: '0',
			sync_type: activityType.myActivityGoods,
			params: {
				page_index: 1,
				page_size: 10,
			},
			list: [],
			content: '',
			options: { selectable: false },
			columns,
			total: '0',
			loading: true,
			exportLoading: false,
			isSearch: false,
			PLATFORM_DY: PLATFORM_DY.value,
		};
	},
	created() {
		this.activityDetail();
	},
	mounted() {
		const { tabName, activity_id, PLATFORM_DY, third_activity_id } = this;
		this.activityList(tabName, activity_id);
		this.$refs.updateTime.getSyncTime(third_activity_id, PLATFORM_DY);
	},
	computed: {
		...mapGetters(['isShopPartnerDataView', 'isAllDataView', 'isDarenPartner']),
		activity_id() {
			return this.$route.query.id;
		},
		third_activity_id() {
			return this.$route.query.third_activity_id;
		},
		team_institution_id() {
			const { institution_info = {} } = this;
			return institution_info.team_institution_id || '';
		},
		authorityId() {
			return this.$route.query.authority_id;
		},
	},
	methods: {
		handleClick() {
			const { tabName, activity_id } = this;
			this.activityList(tabName, activity_id);
		},
		async activityDetail() {
			const { activity_id, PLATFORM_DY: platform_id } = this;
			const { code, data } = await activityDetail({ activity_id, platform_id });
			if (code !== 0) return;
			this.row = data;
		},
		async updateList() {
			const { third_activity_id: item_id, sync_type: type, PLATFORM_DY: platform_id, authorityId: authority_id } = this;
			const { code } = await activitySync({ item_id, type, platform_id, authority_id });
			if (code !== 0) return;
			this.$message({
				iconClass: 'el-icon-info primary mr-10',
				message: '商品正在同步...',
			});
		},
		copyActivityId(val) {
			copy(val);
			this.$message.success('复制成功');
		},
		async activityList(tabName, activity_id, isSearch = false) {
			this.isSearch = isSearch;
			this.loading = true;
			this.params.audit_status = tabName;
			this.params.activity_id = activity_id;
			this.params.authority_id = this.authorityId;
			const { code, data } = await activityList(this.params);
			if (code !== 0) return;
			this.list = data.list.map(item => {
				return {
					...item,
					operations: this.getButtons(item, tabName),
				};
			});
			this.tableArr = data.statistics;
			this.total = data.page.item_total + '';
			this.loading = false;
		},
		//操作按钮
		getButtons(item, tabName) {
			const { isShopPartnerDataView, isAllDataView } = this;
			let arr = [];
			arr.push(
				{
					label: '通过',
					type: 'text',
					classtype: 2,
					isShow: tabName === '0' && (isShopPartnerDataView || isAllDataView) && this.$auth.hasPermi('system:myActivities:commodityAudit'),
					click: row => {
						this.$confirm('是否确认通过?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						}).then(async () => {
							const { code } = await auditActivity({
								activity_id: row.activity_id,
								apply_ids: row.apply_id,
								operation: '0',
								third_product_id: row.third_product_id,
								product_id: row.product_id,
								authority_id: this.authorityId,
							});
							if (code !== 0) return;
							this.$message.success('操作成功');
							this.refreshList();
						});
					},
				},
				{
					label: '拒绝',
					type: 'text',
					classtype: 2,
					isShow: tabName === '0' && (isShopPartnerDataView || isAllDataView) && this.$auth.hasPermi('system:myActivities:commodityAudit'),
					click: row => {
						this.$confirm('是否确认拒绝?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						}).then(async () => {
							const { code } = await auditActivity({
								activity_id: row.activity_id,
								apply_ids: row.apply_id,
								operation: '1',
								third_product_id: row.third_product_id,
								product_id: row.product_id,
								authority_id: this.authorityId,
							});
							if (code !== 0) return;
							this.$message.success('操作成功');
							this.refreshList();
						});
					},
				},
				{
					label: '复制链接',
					type: 'text',
					disabledTooltip: true,
					tooltipContent: '专属链接，达人使用该链接带货产生的订单归属为您的业绩。',
					classtype: 2,
					isShow: tabName === '1',
					click: row => {
						copyFun(row, this);
					},
				},
			);

			return arr.filter(item => item.isShow);
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.$refs['multiTable'].resetPage();
			this.refreshList(true);
		},
		gePartnerList({ page_index, page_size }) {
			this.params.page_index = page_index;
			this.params.page_size = page_size;
			this.refreshList();
		},
		async exportFun() {
			try {
				this.exportLoading = true;
				const { download_url } = await exportActivityList(this.params);
				this.exportLoading = false;
				window.open(download_url, '_blank');
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
				this.exportLoading = false;
			}
		},
		refreshList(isSearch) {
			const { tabName, activity_id } = this;
			this.activityList(tabName, activity_id, isSearch);
		},
	},
};
</script>
<style lang="less" scoped>
.line {
	height: 1px;
	background: #eeeeee;
}

.export {
	display: flex;
	justify-content: end;
	margin-top: 10px;
	margin-bottom: 14px;
}
</style>
